<template>
  <div id="jobs-dropdown">
    <div class="dropdown">
      <button
        type="button"
        class="btn dropdown-toggle d-flex"
        id="jobsDropdownMenu"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-auto-close="outside"
      >
        {{ placeholder }}
      </button>

      <div class="dropdown-menu" v-show="true">
        <ul
          v-if="options.length"
          class="custom-control custom-checkbox"
          aria-labelledby="jobsDropdownMenu"
        >
          <li v-for="item in options" :key="item.id">
            <input
              v-model="model"
              :value="item"
              :id="`${item.id}-${name}`"
              class="mr-2 custom-control-input"
              type="checkbox"
              aria-label
            />

            <label class="custom-control-label" :for="`${item.id}-${name}`"
              >{{ label ? item[label] : item }}{{ item.hasOwnProperty('city') ? ',' : '' }}
              <span class="text-dark">{{
                item.hasOwnProperty('city')
                  ? `${item.city.name ? `${item.city.name}` : 'missing city'}`
                  : '' || item.hasOwnProperty('source_name')
                  ? `(${item.source_name})`
                  : ''
              }}</span>
            </label>
          </li>
        </ul>
        <div v-else>{{ getDropdownCheckboxMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGES } from '../../../constants';

export default {
  components: {},
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    label: String,
    value: Array,
  },

  data() {
    return {
      // selectedItems: this.value,
    };
  },
  methods: {
    /* handleChange(e) {
         this.selectedItems.push(e.target.value);
      this.$emit('item-selected', this.selectedItems);

      this.$emit('change', this.selectedItems);
    }, */
  },
  computed: {
    getDropdownCheckboxMessage() {
      return MESSAGES.dropdownCheckboxMessage;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    options() {
      // this.selectedItems = [];
    },
  },
  mounted() {
    //this.selectedItems = this.selectedItemsFromParrent;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.dropdown {
  button {
    box-shadow: 0px 2px 3px $box-shadow;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>")
      no-repeat !important;
    background-position: right 3px top 50% !important;
    margin-right: 8px !important;
    -webkit-appearance: none;
    -moz-appearance: none;

    &::after {
      display: none;
    }
    color: #4d4f5c;
  }

  .dropdown-menu {
    padding: 10px 5px 10px 10px;
    box-shadow: 2px 2px 5px $box-shadow;
    ul > li:not(:last-child) {
      margin-bottom: 1rem;
    }

    width: 100%;
    margin-top: 5px;

    .custom-control {
      margin-bottom: 0;
    }

    & ul {
      max-height: 550px;
    }

    & ul {
      overflow: hidden;
      overflow-y: scroll;
    }
  }

  button {
    background-color: $color-white;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    width: 100%;
    text-align: left;
  }
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #f05a00;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: #ca4e00;
}
</style>
